import { createContext, useContext } from 'react';

// Lightweight screen switching for the new app shell. State-based for now (no URL
// routing yet) so the new app can live behind /beta without touching the live
// router; the bottom nav and in-screen links both drive it.
export interface NavState {
  current: string;
  go: (id: string) => void;
}
export const NavContext = createContext<NavState | null>(null);
export const useNav = () => useContext(NavContext);

// The five primary destinations shown in the bottom bar.
export const NAV_TABS = [
  { id: 'home', label: 'Home' },
  { id: 'vote', label: 'Vote' },
  { id: 'results', label: 'Results' },
  { id: 'standings', label: 'Table' },
  { id: 'chat', label: 'Chat' },
];
